import ViewQuotesWrapper from './ViewQuotesWrapper';
export default ViewQuotesWrapper;
